// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import ContextProvider from './components/Context';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <ContextProvider>
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
//   </ContextProvider>

// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();




import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from "./Features/Store";
import ContextProvider from './components/Context';
// Import the unregister function from your serviceWorker.js file
import { unregister } from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
    <ContextProvider>
      <HelmetProvider>
<App />
      </HelmetProvider>
    
    </ContextProvider>
    </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Unregister the service worker (disables offline support)
unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
